import { track } from "jiffy-analytics";
import { isTouchDevice } from "common/utils/browser";
import { on as onEvent } from "common/utils/ui/event";
import "./component.scss";

export const urlEnum = {
  print_compositions: "print_compositions"
};

const CLASS_NAMES = {
  JS_SCORE_TOOLTIP: ".js-softness-score-tooltip",
  JS_SCORE_NUMBER: ".js-softness-score-number",
  SOFTNESS_SCORE: ".softness-score",
  SOFTNESS_SCORE_MINI: ".softness-score-mini__number",
  LEARN_MORE: ".softness-score__learn-more"
};

const DPD_DYNAMIC_SOURCES = ["product_details_user_feedback", "product_color_picker"];

const tooltipContent = `
  <div
    class="softness-score__tooltip-content"
    id="js-softness-score-tooltip-content"
  >
    <div class="softness-score__tooltip-head">
      <div class="softness-score__tooltip-icon"></div>
      <h5 class="softness-score__tooltip-title">
        <b>CozyFeel™</b>, verified by Jiffy
      </h5>
      <a
        class="softness-score__tooltip-close js-softness-score-tooltip-close"
        role="button"
        tabindex="-1"
      ></a>
    </div>
    <div class="softness-score__tooltip-body">
      <ol class="softness-score__tooltip-list">
        <li class="softness-score__tooltip-list-item">
          <b class="softness-score__tooltip-list-taxon">Rough:</b>
          Rugged and textured.
        </li>
        <li class="softness-score__tooltip-list-item">
          <b class="softness-score__tooltip-list-taxon">Coarse:</b>
          Noticeable texture.
        </li>
        <li class="softness-score__tooltip-list-item">
          <b class="softness-score__tooltip-list-taxon">Everyday:</b>
          Soft and comfortable.
        </li>
        <li class="softness-score__tooltip-list-item">
          <b class="softness-score__tooltip-list-taxon">Smooth:</b>
          Incredible softness.
        </li>
        <li class="softness-score__tooltip-list-item">
          <b class="softness-score__tooltip-list-taxon">Luxe:</b>
          Luxurious and velvety.
        </li>
      </ol>

      <div class="softness-score__learn-more-wrap">
        <a class="softness-score__learn-more" href="/help#cozyfeel" ${
          window.MOBILE_APP ? "" : 'target="_blank"'
        }>
          Learn More
        </a>
      </div>
    </div>
  </div>`;
const tooltipTemplate = `
  <div class="tooltip softness-score__tooltip" role="tooltip">
    <div class="softness-score__tooltip-arrow tooltip-arrow"></div>
    <div class="softness-score__tooltip-inner tooltip-inner"></div>
  </div>`;

const $getTooltips = () => document.querySelectorAll(".js-softness-score-tooltip");
const $$getTooltips = () => $(".js-softness-score-tooltip");

/*  Bootstrap tooltips to stay open on hover https://stackoverflow.com/a/36056707 */
export const initStayOpenOnHover = () => {
  const originalLeave = $.fn.tooltip.Constructor.prototype.leave;

  $.fn.tooltip.Constructor.prototype.leave = function leave(event) {
    const { currentTarget } = event;
    const options = this.getDelegateOptions();
    const dynamicDataValue = $(currentTarget)[this.type](options).data(`bs.${this.type}`);
    const self = event instanceof this.constructor ? event : dynamicDataValue;

    originalLeave.call(this, event);

    if (currentTarget) {
      const $$container = $(`#${$(currentTarget).attr("aria-describedby")}`);
      const hasLink = !!$("a[href]", $$container).length;
      if (!hasLink) return;

      const { timeout } = self;
      $$container.one("mouseenter", () => {
        clearTimeout(timeout);

        $$container.one("mouseleave", () => {
          $.fn.tooltip.Constructor.prototype.leave.call(self, self);
        });
      });
    }
  };
};

const $getSoftnessTooltip = $element => {
  const $tooltip = $element
    .closest(CLASS_NAMES.JS_SCORE_TOOLTIP)
    ?.querySelector(CLASS_NAMES.JS_SCORE_NUMBER);

  if ($tooltip) {
    return $tooltip;
  }

  return (
    $element
      .closest(CLASS_NAMES.JS_SCORE_TOOLTIP)
      ?.querySelector(CLASS_NAMES.SOFTNESS_SCORE_MINI) || null
  );
};

const getPageType = () => {
  const currentUrl = window.location.href.replace(/\/+$/, ""); // Remove trailing slashes

  if (currentUrl.includes(".html")) {
    return "detail_page";
  }
  if (currentUrl === window.location.origin || currentUrl === `${window.location.origin}/`) {
    return "home_page";
  }
  return "listing_page";
};

let isLearnMoreOnEventAttached = false;
let activeSoftnessPayload = {};
const initTrackLearnMoreClick = () => {
  if (isLearnMoreOnEventAttached) return;

  const callback = _ => {
    track("cozy_feel_learn_more_clicked", activeSoftnessPayload);
  };

  onEvent("click", CLASS_NAMES.LEARN_MORE, callback, true);
  isLearnMoreOnEventAttached = true;
};

const trackCozyFeelBadgeOpened = $element => {
  const $softnessTooltip = $getSoftnessTooltip($element);
  const score = $softnessTooltip?.textContent.trim() || "";

  const dataset = $softnessTooltip?.dataset;
  const page = dataset?.source?.includes("page") ? dataset.source : getPageType();
  const source = dataset?.source || "left_nav";
  let compositionName = dataset?.compositionName || "";

  if (page === "detail_page" && DPD_DYNAMIC_SOURCES.includes(source)) {
    const urlParams = new URLSearchParams(window.location.search);
    compositionName = urlParams.get("ac") || compositionName;
  }

  const softnessPayload = {
    score,
    source,
    composition_name: compositionName,
    catalog_number: dataset?.catalogNumber || "",
    page
  };

  track("cozy_feel_badge_opened", softnessPayload);
  activeSoftnessPayload = softnessPayload;
};

const initTooltip = () => {
  const $$tooltips = $$getTooltips();

  // Unbind any existing event handlers to prevent duplicate bindings
  $$tooltips.off("shown.bs.tooltip");

  $$tooltips
    .tooltip({
      animation: false,
      container: "body",
      delay: {
        show: isTouchDevice() ? 0 : 500,
        hide: 100
      },
      html: true,
      title: tooltipContent,
      template: tooltipTemplate,
      trigger: isTouchDevice() ? "click" : "hover"
    })
    .on("shown.bs.tooltip", function shownCallback() {
      $$tooltips.not(this).tooltip("hide");

      trackCozyFeelBadgeOpened(this);
    });
};

const initTooltipClose = () => {
  const callback = e => {
    e.preventDefault();
    $$getTooltips().tooltip("hide");
  };

  onEvent("click", ".js-softness-score-tooltip-close", callback, true);
};

const stopBubbling = () => {
  $getTooltips().forEach($badge => {
    $badge.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
    });
  });
};

const init = () => {
  const currUrl = window.location.href;

  const isPrintCompositionsPage = currUrl.includes(urlEnum.print_compositions);

  initStayOpenOnHover();

  if (!isPrintCompositionsPage) {
    initTooltip();
    initTrackLearnMoreClick();
  }

  initTooltipClose();
  stopBubbling();
};

export default init;
